import { createDynamicFiltersAdapter } from "./factory";

const dynamicFiltersAdapter = createDynamicFiltersAdapter();

export default dynamicFiltersAdapter;
